import React from 'react';
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    DateField
} from 'react-admin';

import { required, maxLength, minLength, email, number } from './../../utils/validations';

const defaultValues = { merchantId: sessionStorage.getItem("merchantId") };

export const MerchantAdminList = (props) => (
    <List {...props} title={`Admins`} bulkActionButtons={false}
        sort={{ field: "creationTime", order: "DESC" }}>
        <Datagrid>
            <TextField source="fullName" label="Name" />
            <TextField source="userName" label="Username" />
            <TextField source="emailId" label="Email" />
            <TextField source="mobileNo" label="Mobile" />
            <DateField source="creationTime" showTime label="Order Time" />
            <EditButton />
        </Datagrid>
    </List>
);

const validateName = [required(), minLength(2), maxLength(35)];
const validatePhone = [required(), number('Must be a valid phone number'), minLength(10), maxLength(15)];
const validatePassword = [required(), minLength(5)];

export const MerchantAdminEdit = (props) => (
    <Edit title={`Edit Admins`} {...props}>
        <SimpleForm redirect="list" {...props}>
            <TextInput label="Name" source="fullName" validate={validateName} />
            <TextInput disabled label="Username" source="userName" />
            <TextInput label="Email Address" source="emailId" validate={email()} />
            <TextInput label="Mobile Number" source="mobileNo" validate={validatePhone} />
        </SimpleForm>
    </Edit>
);

export const MerchantAdminCreate = (props) => (
    <Create title={`Create Admins`} {...props}>
        <SimpleForm redirect="list" defaultValue={defaultValues}>
            <TextInput label="First Name" source="firstName" validate={validateName} />
            <TextInput label="Last Name" source="lastName" validate={validateName} />
            <TextInput label="Username" source="userName" validate={validateName} />
            <TextInput label="Password" source="password" type="password" validate={validatePassword} />
            <TextInput label="Email Address" source="emailId" validate={email()} />
            <TextInput label="Mobile Number" source="mobileNo" validate={validatePhone} />
        </SimpleForm>
    </Create>
);
